import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export abstract class SkogsvardTradslagBaseCommand extends BasicCommand<SkogsvardTradslagBaseCommand> {
    guid: string;
    atgardGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "SkogsvardTradslag";

    get primaryKey(): ISkogsvardTradslagPrimaryKey {
        return {
            guid: this.guid,
            atgardGuid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, guid: string, $type: string, commandType: CommandType) {
        super($type, SkogsvardTradslagBaseCommand.$groupKey, commandType);
        this.atgardGuid = atgardGuid;
        this.guid = guid;
    }
}

export interface ISkogsvardTradslagPrimaryKey extends IPrimaryKey<ISkogsvardTradslagPrimaryKey> {
    guid: string;
    atgardGuid: string;
}
